var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgriculture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.005,
    height: 16.955,
    viewBox: "0 0 17.005 16.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1.25 -1.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87764",
    "data-name": "Path 87764",
    d: "M5.958,20.763a5.538,5.538,0,0,1,10.333,0,.593.593,0,0,1-.554.807H6.511a.593.593,0,0,1-.554-.807Z",
    transform: "translate(-0.976 -3.332)",
    fill: "#015ca3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87765",
    "data-name": "Path 87765",
    d: "M11.586,15.329a.593.593,0,1,1-1.158-.258,13.066,13.066,0,0,0,0-4.957A6.246,6.246,0,0,0,7.544,5.826a.593.593,0,0,1,.6-1.025,7.409,7.409,0,0,1,3.445,5.064A14.388,14.388,0,0,1,11.586,15.329Z",
    transform: "translate(-1.254 -0.719)",
    fill: "#015ca3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87766",
    "data-name": "Path 87766",
    d: "M12.745,13.2a.593.593,0,1,1-1.163-.234,6.4,6.4,0,0,1,2.047-3.082.593.593,0,0,1,.815.862,5.6,5.6,0,0,0-1.7,2.454Z",
    transform: "translate(-2.157 -1.764)",
    fill: "#015ca3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87767",
    "data-name": "Path 87767",
    d: "M14.213,10.7A4.665,4.665,0,0,1,13.94,9.28,2.511,2.511,0,0,1,15.3,6.828a4.77,4.77,0,0,1,5.464.93.594.594,0,0,1-.26.952,3.365,3.365,0,0,0-1.634,1.679,3.487,3.487,0,0,1-2.052,1.6,2.25,2.25,0,0,1-1.439-.049,1.9,1.9,0,0,1-.443-.252,8.319,8.319,0,0,1,.8-.858.593.593,0,0,0-.815-.862A9.861,9.861,0,0,0,14.213,10.7Z",
    transform: "translate(-2.653 -1.059)",
    fill: "#015ca3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87768",
    "data-name": "Path 87768",
    d: "M7.6,8.485a2.38,2.38,0,0,1-.878.213,2.873,2.873,0,0,1-2.209-1.1A8.2,8.2,0,0,1,3.283,5.65,14.1,14.1,0,0,0,1.4,3.028a.594.594,0,0,1,.2-.94C3.923,1.071,6.738.8,8.937,2.564a2.634,2.634,0,0,1,.939,2.824A6.325,6.325,0,0,1,8.616,7.77l-.022.024A6.92,6.92,0,0,0,5.7,4.478.593.593,0,1,0,5.1,5.5,5.81,5.81,0,0,1,7.6,8.485Z",
    transform: "translate(0 0)",
    fill: "#015ca3",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgriculture);
export default __webpack_public_path__ + "static/media/agriculture.9ae8eb655766181402cf886af9a0285c.svg";
export { ForwardRef as ReactComponent };